import { render, staticRenderFns } from "./montHead.vue?vue&type=template&id=e0f6e1fc&scoped=true"
import script from "./montHead.vue?vue&type=script&lang=js"
export * from "./montHead.vue?vue&type=script&lang=js"
import style0 from "./montHead.vue?vue&type=style&index=0&id=e0f6e1fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f6e1fc",
  null
  
)

export default component.exports